import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'zeudy-bunny',
  shadow: false,
})
export class zeudyBunny {
  @Prop({ mutable: true }) getRef?: (elm?: HTMLVideoElement) => void;
  @Prop() autoplay: boolean;
  @Prop() src: string;
  @Prop() preload: string;
  @Prop({ mutable: true }) poster: string;
  @Prop() player: any;
  @Prop() tracks: { label: string; src: string; srcLang: string }[];
  @Prop() playsinline: boolean;
  @Prop() provider: string;
  @Prop() thumbnail: string;
  @Prop() previewUrl: string;
  @Prop() videoAttributes: object;

  componentWillLoad() {
    this.poster = this.poster || this.thumbnail; // maybe add bunny thumbnail
  }

  render() {
    return (
      <zeudy-video
        getRef={this.getRef}
        player={this.player}
        autoplay={this.autoplay}
        preload={this.preload}
        poster={this.poster}
        playsinline={this.playsinline}
        src={this.src}
        tracks={this.tracks}
        videoAttributes={this.videoAttributes}
      ></zeudy-video>
    );
  }
}
